import React from "react";
import styled from "styled-components";

export default function MaxBookedInput(props) {
  const { value, setValue, placeholder, isLock } = props;

  // 변수 변경시 //
  function onChange(e) {
    setValue(e.target.value);
  }

  return (
    <InputBox isLock={isLock}>
      <Input
        value={isLock ? 'Locked' : value}
        onChange={isLock ? undefined : onChange}
        readOnly={isLock}
        placeholder={placeholder}
        isLock={isLock} />
    </InputBox>
  );
}

const InputBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px ${props => props.isLock ? '5px' : '10px'};

  box-sizing: border-box;
  width: 100%;
  height: 32px;

  border: 1px solid ${props => props.isLock ? props.theme.pointRed : props.theme.line};
  border-radius: 5px;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;

  opacity: 1;

  margin: 0 0 0 0;

  width: 100%;
  height: 100%;

	outline: none;
  border: 0px solid ${props => props.theme.line};

	color: ${props => props.isLock ? props.theme.pointRed : props.theme.text};

  background-color: transparent;

  text-align: right;

	::placeholder {
    font-family: NotoSansKR-Regular;
    font-size: 14px;
    
		color: ${props => props.theme.line};
	}
`;
